// extracted by mini-css-extract-plugin
module.exports = {"layout":"ai_layout__wVXcy"};